<template>
  <div class="box_ent">
    <div class="enterpriseInformationInfo">
      <div class="name">
        {{list.text}}
      </div>
      <div class="time">
        发表时间：{{list.time}}
      </div>
      <div class="box_ent_info" v-html="list.info"></div>
      <div class="core_top">
        <span @click="black">返回上一页</span>
      </div>
    </div>
  </div>
</template>

<script>
import {enterpriseList} from "@/views/mock";

export default {
  name: "enterpriseInformationInfo",
  data(){
    return{
      list:{}
    }
  },
  created(){
    let arr = enterpriseList.filter((item)=>{
      return item.id == this.$route.query.id
    })
    console.log(arr)
    this.list = arr[0]
  },
  methods:{
    black(){
      window.history.back()
    }
  }
}
</script>

<style scoped lang="scss">
.box_ent{
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 50px 0;
}
.enterpriseInformationInfo{
  width: 1400px;
  .name{
    font-size: 74px;
    font-weight: bold;
  }
  .time{
    margin-top: 30px;
    font-size: 50px;
    color: rgb(107,107,107);
  }
  .box_ent_info{
    margin-top: 40px;
    border-top: 2px solid rgb(217,217,217);
    border-bottom: 2px solid rgb(217,217,217);
    padding: 30px 0;
    font-size: 56px;
  }
  .core_top{
    font-size: 54px;
    padding: 34px 0;
    cursor: pointer;
  }
}
</style>
